import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  description: {
    fontFamily: 'Roboto !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    color: '#000000DE',
    letterSpacing: '0.15px !important',
    lineHeight: '175% !important',
  },
  containerTitle: {
    display: 'grid',
    gap: '16px',
  },
  containerForm: {
    width: '380px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      marginTop: '16px !important',
    },
  },
  buttonOutlined: {
    borderRadius: '20px !important',
    fontFamily: 'Roboto !important',
    fontSize: '14px !important',
    border: `1px solid ${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    width: '100%',
  },
  containerLink: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  divider: {
    margin: '10px 0px',
  },
  containerCreateUser: {
    display: 'grid',
    gap: '20px',
    marginTop: 20,
  },
  fakeStyle: {
    position: 'fixed',
    width: '0px',
    height: '0px',
    top: '-1000px',
    left: '-1000px',
    background: 'white',
    border: 'none',
  },
  title: {
    color: '#000000DE',
    fontFamily: 'Roboto !important',
    fontSize: '22px !important',
    fontStyle: 'normal',
    fontWeight: '600  !important',
    lineHeight: '133.4%',
  },
  button: {
    borderRadius: '20px !important',
    fontSize: '14px !important',
    backgroundColor: `${theme.palette.primary.main} !important`,
    width: '100%',
    marginTop: '32px !important',
    marginBottom: '32px !important',
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
    [theme.breakpoints.down('md')]: {
      marginTop: '30px !important',
      marginBottom: '30px !important',
    },
  },
  buttonDisabled: {
    borderRadius: '20px !important',
    fontSize: '14px !important',
    backgroundColor: `rgba(0, 0, 0, 0.12) !important`,
    width: '100%',
    marginTop: '32px !important',
    marginBottom: '32px !important',
    [theme.breakpoints.down('md')]: {
      marginTop: '30px !important',
      marginBottom: '30px !important',
    },
  },
  helperText: {
    display: 'flex',
    justifyContent: 'space-between',
    color: 'red !important',
  },
}));
